import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { MenuIcon, XIcon } from "lucide-react";
import { useLanguage } from "../i18n/LanguageContext";
import { company, images } from "../i18n/translations";
const links = [{
  id: "inicio",
  href: "#inicio"
}, {
  id: "nosotros",
  href: "#nosotros"
}, {
  id: "productos",
  href: "#productos"
}, {
  id: "capacidad",
  href: "#capacidad"
}, {
  id: "galeria",
  href: "#galeria"
}, {
  id: "contacto",
  href: "#contacto"
}] as const;
export function Navbar() {
  const {
    t,
    lang,
    setLang
  } = useLanguage();
  const [open, setOpen] = useState(false);
  const [isVisible, setIsVisible] = useState(true);
  const previousScrollY = useRef(0);
  useEffect(() => {
    const onScroll = () => {
      const currentScrollY = window.scrollY;
      const isScrollingDown = currentScrollY > previousScrollY.current;
      if (currentScrollY < 24 || !isScrollingDown) {
        setIsVisible(true);
      } else if (currentScrollY - previousScrollY.current > 5) {
        setIsVisible(false);
      }
      previousScrollY.current = currentScrollY;
    };
    window.addEventListener("scroll", onScroll, {
      passive: true
    });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  return <header className={"fixed top-0 inset-x-0 z-50 bg-white shadow-md transition-transform duration-300 " + (isVisible || open ? "translate-y-0" : "-translate-y-full")} data-id="element-91" data-mp="olqj10nwvpt9">
      <nav className="max-w-content mx-auto px-4 sm:px-6 h-[72px] flex items-center justify-between" aria-label="Principal" data-id="element-92" data-mp="3s279ymzzlg41">
        <Link to="/" className="flex shrink-0" aria-label={company.name} data-id="element-93" data-mp="ul2ske26vif">
          <img src={images.logo} alt="GRANSACA" className="h-14 w-auto" width={168} height={63} data-id="element-94" data-mp="5nxoalnfym6y" />
        </Link>

        {/* Desktop links */}
        <ul className="hidden lg:flex items-center gap-7" data-id="element-95" data-mp="39ao84jhp883l">
          {links.map(l => <li key={l.id} data-id="element-96" data-mp="31a88vj3kix6j">
              <Link to={`/${l.href}`} className="text-[15px] font-medium text-navy transition-colors hover:text-orange" data-id="element-97" data-mp="319gicmotvpn4">
                {t.nav[l.id]}
              </Link>
            </li>)}
        </ul>

        <div className="flex items-center gap-3" data-id="element-98" data-mp="361q9u75lcxri">
          <LangSelector solid={true} lang={lang} setLang={setLang} data-id="element-99" data-mp="364cdhvpd2t4g" />

          <Link to="/#contacto" className="hidden md:inline-flex items-center rounded-sm bg-orange px-4 py-2 text-sm font-semibold text-white transition-colors hover:bg-orange-dark" data-id="element-100" data-mp="2icxiyp3ttg3r">
            {t.nav.cotizar}
          </Link>

          <button type="button" onClick={() => setOpen(v => !v)} className="lg:hidden p-2 text-navy" aria-label="Menú" aria-expanded={open} data-id="element-101" data-mp="2naz1n8xcbdep">
            {open ? <XIcon size={26} data-id="element-102" data-mp="2khr7l31htvq" /> : <MenuIcon size={26} data-id="element-103" data-mp="2kzx79fi7mgu" />}
          </button>
        </div>
      </nav>

      {/* Mobile menu */}
      {open && <div className="lg:hidden bg-white border-t border-slate-100 shadow-lg" data-id="element-104" data-mp="a753qos1a5ta">
          <ul className="px-4 py-3" data-id="element-105" data-mp="f1sjnz8z1rw9">
            {links.map(l => <li key={l.id} data-id="element-106" data-mp="15fd3l5z7awk">
                <Link to={`/${l.href}`} onClick={() => setOpen(false)} className="block py-3 text-navy font-medium border-b border-slate-100 last:border-0" data-id="element-107" data-mp="1670i8pf62br">
                  {t.nav[l.id]}
                </Link>
              </li>)}
          </ul>
          <div className="px-4 pb-4" data-id="element-108" data-mp="k383jnzexsd2">
            <Link to="/#contacto" onClick={() => setOpen(false)} className="block text-center rounded-sm bg-orange px-4 py-3 text-sm font-semibold text-white" data-id="element-109" data-mp="k26utq5vdhyi">
              {t.nav.cotizar}
            </Link>
          </div>
        </div>}
    </header>;
}
function LangSelector({
  solid,
  lang,
  setLang
}: {
  solid: boolean;
  lang: "es" | "en";
  setLang: (l: "es" | "en") => void;
}) {
  const base = "px-2 py-1 text-xs font-bold uppercase tracking-wide rounded-sm transition-colors";
  return <div className={"flex items-center gap-0.5 rounded-sm border p-0.5 " + (solid ? "border-slate-200" : "border-white/40")} role="group" aria-label="Language selector" data-id="element-110" data-mp="3f37u59mqx1sc">
      {(["es", "en"] as const).map(l => {
      const active = lang === l;
      return <button key={l} type="button" onClick={() => setLang(l)} aria-pressed={active} className={base + " " + (active ? "bg-orange text-white" : solid ? "text-navy hover:bg-slate-100" : "text-white hover:bg-white/10")} data-id="element-111" data-mp="6oz8klin5b9o">
            {l}
          </button>;
    })}
    </div>;
}